import store from '../../../../state';
import { getAllActivities } from '../../../../config';
import { ForecastWidgetConfig, WidgetRenderContext, WidgetRenderer } from '../types';

export class PersonaChipsWidget implements WidgetRenderer {
  public renderHtml(widget: ForecastWidgetConfig, ctx: WidgetRenderContext): string {
    const title = widget.title || 'Activity Selector';
    const activePersona = ctx.activePersonaId;

    const state = store.getState();
    const allActivities = getAllActivities(state.customActivities);
    const defaultIds = ['standard_forecast', 'hiking', 'photography', 'stargazing', 'winter_sports', 'water_sports'];
    const rawList = (state.enabledActivities && state.enabledActivities.length > 0)
      ? state.enabledActivities
      : defaultIds;

    // Hide 'advanced' (All Map Layers) from activities and ensure 'standard_forecast' is always first
    const filteredList = rawList.filter(id => id !== 'advanced' && id !== 'all_map_layers');
    const activeList = ['standard_forecast', ...filteredList.filter(id => id !== 'standard_forecast')];

    // If current map persona is All Map Layers ('advanced'), the rendered detailed forecast is Standard Forecast
    const effectiveActivePersona = (activePersona === 'advanced' || activePersona === 'all_map_layers')
      ? 'standard_forecast'
      : activePersona;

    const chipsHtml = activeList.map(actId => {
      const act = allActivities[actId];
      if (!act) return '';
      const isActive = act.id === effectiveActivePersona;
      const bg = isActive ? 'linear-gradient(135deg, #00d4ff 0%, #0284c7 100%)' : 'rgba(255, 255, 255, 0.05)';
      const color = isActive ? '#090a0f' : '#cbd5e1';
      const border = isActive ? '1px solid #38bdf8' : '1px solid rgba(255, 255, 255, 0.08)';
      const weight = isActive ? '700' : '500';

      return `
        <button class="persona-chip-btn" data-persona-id="${act.id}" style="display: inline-flex; align-items: center; gap: 6px; padding: 6px 12px; border-radius: 999px; background: ${bg}; color: ${color}; border: ${border}; font-weight: ${weight}; font-size: 0.75rem; cursor: pointer; transition: all 0.15s ease;">
          <span>${act.icon}</span>
          <span>${act.title}</span>
        </button>
      `;
    }).join('');

    return `
      <div class="metric-card" data-widget-id="${widget.id}" style="background: linear-gradient(145deg, #13151f 0%, #0d0e15 100%); border: 1px solid rgba(255, 255, 255, 0.08); border-radius: 14px; padding: 12px 16px; box-shadow: 0 8px 24px rgba(0,0,0,0.3);">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
          <span style="font-size: 0.8rem; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.5px;">${title}</span>
        </div>
        <div style="display: flex; gap: 8px; flex-wrap: wrap;">
          ${chipsHtml}
        </div>
      </div>
    `;
  }

  public init(widget: ForecastWidgetConfig, ctx: WidgetRenderContext): void {
    const container = document.querySelector(`[data-widget-id="${widget.id}"]`) || document;
    const buttons = container.querySelectorAll('.persona-chip-btn');
    buttons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const pId = (btn as HTMLElement).getAttribute('data-persona-id');
        if (!pId || pId === ctx.activePersonaId) return;

        try {
          localStorage.setItem('gw_active_persona', pId);
        } catch (err) {
          console.warn('Could not save persona to localStorage:', err);
        }
        store.update({ activePersona: pId as any });
      });
    });
  }
}
